import DealerDetailScreen from 'features/ManageDealer/screens/DealerDetailScreen';
import InvestorGroupPackageListScreen from 'features/ManageGroup/screens/InvestorGroupPackageListScreen';
import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';

InvestorGroupPackHistory.propTypes = {};

function InvestorGroupPackHistory(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-4 my-4">
                <Routes>
                    <Route path="" element={<InvestorGroupPackageListScreen />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default InvestorGroupPackHistory;
